export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["ObjectForbidden"] = "ERROR_OBJECT_FORBIDDEN";
    ErrorCodes["AttemptsExceeded"] = "ERROR_ATTEMPTS_EXCEEDED";
    ErrorCodes["NoExistsDealsForReview"] = "ERROR_NO_EXISTS_DEALS_FOR_REVIEW";
    ErrorCodes["NotFound"] = "AGENT_NOT_FOUND";
    ErrorCodes["ProfileDisabled"] = "AGENT_PROFILE_DISABLED";
})(ErrorCodes || (ErrorCodes = {}));
